export function keyDownAsClick(fn: () => void) {
    return function (ev: React.KeyboardEvent): void {
        if (ev.repeat) return;
        if (ev.code !== 'Enter' && ev.code !== 'Space') return;
        fn();
        // Prevent scroll when pressing space bar.
        ev.preventDefault();
    };
}
